// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,json_types=true"
// @generated from file pickup_location.proto (package raccoonai, syntax proto2)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { ContainerGroup, ContainerGroupJson } from "./container_group_pb";
import { file_container_group } from "./container_group_pb";
import type { Contract, ContractJson } from "./contract_pb";
import { file_contract } from "./contract_pb";
import type { JobType, JobTypeJson, LocationStatus, LocationStatusJson, PickupLocationPriority, PickupLocationPriorityJson, PickupLocationType, PickupLocationTypeJson } from "./enums_pb";
import { file_enums } from "./enums_pb";
import type { ListInfo, ListInfoJson, OrganizationLabel, OrganizationLabelJson, UserRef, UserRefJson } from "./general_pb";
import { file_general } from "./general_pb";
import type { StructJson, Timestamp, TimestampJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_struct, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { JsonObject, Message } from "@bufbuild/protobuf";

/**
 * Describes the file pickup_location.proto.
 */
export const file_pickup_location: GenFile = /*@__PURE__*/
  fileDesc("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", [file_container_group, file_contract, file_enums, file_general, file_google_protobuf_struct, file_google_protobuf_timestamp]);

/**
 * @generated from message raccoonai.PickupLocation
 */
export type PickupLocation = Message<"raccoonai.PickupLocation"> & {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: required string name = 3;
   */
  name: string;

  /**
   * @generated from field: required raccoonai.PickupLocationType type = 4;
   */
  type: PickupLocationType;

  /**
   * will be deprecated
   *
   * @generated from field: optional uint64 owner_organization_id = 5 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;

  /**
   * will be required
   *
   * @generated from field: optional uint64 service_provider_id = 6 [json_name = "service_provider_id"];
   */
  serviceProviderId: bigint;

  /**
   * @generated from field: required raccoonai.LocationStatus status = 7;
   */
  status: LocationStatus;

  /**
   * @generated from field: required double lon = 8;
   */
  lon: number;

  /**
   * @generated from field: required double lat = 9;
   */
  lat: number;

  /**
   * @generated from field: optional google.protobuf.Struct geometry = 10;
   */
  geometry?: JsonObject;

  /**
   * @generated from field: optional string address = 11;
   */
  address: string;

  /**
   * @generated from field: optional string availability_schedule = 12 [json_name = "availability_schedule"];
   */
  availabilitySchedule: string;

  /**
   * @generated from field: optional string notification_schedule = 13 [json_name = "notification_schedule"];
   */
  notificationSchedule: string;

  /**
   * To be deprecated in favor of container_groups
   *
   * @generated from field: optional uint64 num_containers = 14 [json_name = "num_containers"];
   */
  numContainers: bigint;

  /**
   * @generated from field: optional raccoonai.PickupLocationPriority priority = 15;
   */
  priority: PickupLocationPriority;

  /**
   * @generated from field: optional string geo_group = 16 [json_name = "geo_group"];
   */
  geoGroup: string;

  /**
   * To be deprecated in favor of contract.tariff_rate_by_job_type
   *
   * @generated from field: optional uint64 tariff = 17;
   */
  tariff: bigint;

  /**
   * @generated from field: optional uint64 receiver_user_id = 18 [json_name = "receiver_user_id"];
   */
  receiverUserId: bigint;

  /**
   * To be deprecated in favor of container_groups.contract_id
   *
   * @generated from field: optional uint64 contract_id = 19 [json_name = "contract_id"];
   */
  contractId: bigint;

  /**
   * @generated from field: optional string comment = 20;
   */
  comment: string;

  /**
   * @generated from field: optional string gis_link = 21 [json_name = "gis_link"];
   */
  gisLink: string;

  /**
   * @generated from field: optional uint64 service_time = 22 [json_name = "service_time"];
   */
  serviceTime: bigint;

  /**
   * ID of primary contact
   *
   * @generated from field: optional uint64 primary_contact_id = 23 [json_name = "primary_contact_id"];
   */
  primaryContactId: bigint;

  /**
   * @generated from field: optional string plan_waste_volume = 24 [json_name = "plan_waste_volume"];
   */
  planWasteVolume: string;

  /**
   * @generated from field: optional string plan_waste_mass = 25 [json_name = "plan_waste_mass"];
   */
  planWasteMass: string;

  /**
   * @generated from field: repeated raccoonai.ContainerGroup container_groups = 26 [json_name = "container_groups"];
   */
  containerGroups: ContainerGroup[];

  /**
   * @generated from field: optional uint64 manager_id = 27 [json_name = "manager_id"];
   */
  managerId: bigint;

  /**
   * @generated from field: optional raccoonai.UserRef manager = 28;
   */
  manager?: UserRef;

  /**
   * BY_NORM contracts covering this location. Set where the caller preloads them
   * (ListPickupLocations / GetPickupLocationById).
   *
   * @generated from field: repeated raccoonai.Contract subscription_contracts = 29 [json_name = "subscription_contracts"];
   */
  subscriptionContracts: Contract[];

  /**
   * Unset: no type («Неопределено»).
   *
   * @generated from field: optional uint64 pickup_location_type_id = 30 [json_name = "pickup_location_type_id"];
   */
  pickupLocationTypeId: bigint;

  /**
   * @generated from field: optional raccoonai.OrganizationLabel pickup_location_type = 31 [json_name = "pickup_location_type"];
   */
  pickupLocationType?: OrganizationLabel;

  /**
   * @generated from field: required google.protobuf.Timestamp created_at = 101 [json_name = "created_at"];
   */
  createdAt?: Timestamp;
};

/**
 * @generated from message raccoonai.PickupLocation
 */
export type PickupLocationJson = {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id?: string;

  /**
   * @generated from field: required string name = 3;
   */
  name?: string;

  /**
   * @generated from field: required raccoonai.PickupLocationType type = 4;
   */
  type?: PickupLocationTypeJson;

  /**
   * will be deprecated
   *
   * @generated from field: optional uint64 owner_organization_id = 5 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;

  /**
   * will be required
   *
   * @generated from field: optional uint64 service_provider_id = 6 [json_name = "service_provider_id"];
   */
  service_provider_id?: string;

  /**
   * @generated from field: required raccoonai.LocationStatus status = 7;
   */
  status?: LocationStatusJson;

  /**
   * @generated from field: required double lon = 8;
   */
  lon?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: required double lat = 9;
   */
  lat?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional google.protobuf.Struct geometry = 10;
   */
  geometry?: StructJson;

  /**
   * @generated from field: optional string address = 11;
   */
  address?: string;

  /**
   * @generated from field: optional string availability_schedule = 12 [json_name = "availability_schedule"];
   */
  availability_schedule?: string;

  /**
   * @generated from field: optional string notification_schedule = 13 [json_name = "notification_schedule"];
   */
  notification_schedule?: string;

  /**
   * To be deprecated in favor of container_groups
   *
   * @generated from field: optional uint64 num_containers = 14 [json_name = "num_containers"];
   */
  num_containers?: string;

  /**
   * @generated from field: optional raccoonai.PickupLocationPriority priority = 15;
   */
  priority?: PickupLocationPriorityJson;

  /**
   * @generated from field: optional string geo_group = 16 [json_name = "geo_group"];
   */
  geo_group?: string;

  /**
   * To be deprecated in favor of contract.tariff_rate_by_job_type
   *
   * @generated from field: optional uint64 tariff = 17;
   */
  tariff?: string;

  /**
   * @generated from field: optional uint64 receiver_user_id = 18 [json_name = "receiver_user_id"];
   */
  receiver_user_id?: string;

  /**
   * To be deprecated in favor of container_groups.contract_id
   *
   * @generated from field: optional uint64 contract_id = 19 [json_name = "contract_id"];
   */
  contract_id?: string;

  /**
   * @generated from field: optional string comment = 20;
   */
  comment?: string;

  /**
   * @generated from field: optional string gis_link = 21 [json_name = "gis_link"];
   */
  gis_link?: string;

  /**
   * @generated from field: optional uint64 service_time = 22 [json_name = "service_time"];
   */
  service_time?: string;

  /**
   * ID of primary contact
   *
   * @generated from field: optional uint64 primary_contact_id = 23 [json_name = "primary_contact_id"];
   */
  primary_contact_id?: string;

  /**
   * @generated from field: optional string plan_waste_volume = 24 [json_name = "plan_waste_volume"];
   */
  plan_waste_volume?: string;

  /**
   * @generated from field: optional string plan_waste_mass = 25 [json_name = "plan_waste_mass"];
   */
  plan_waste_mass?: string;

  /**
   * @generated from field: repeated raccoonai.ContainerGroup container_groups = 26 [json_name = "container_groups"];
   */
  container_groups?: ContainerGroupJson[];

  /**
   * @generated from field: optional uint64 manager_id = 27 [json_name = "manager_id"];
   */
  manager_id?: string;

  /**
   * @generated from field: optional raccoonai.UserRef manager = 28;
   */
  manager?: UserRefJson;

  /**
   * BY_NORM contracts covering this location. Set where the caller preloads them
   * (ListPickupLocations / GetPickupLocationById).
   *
   * @generated from field: repeated raccoonai.Contract subscription_contracts = 29 [json_name = "subscription_contracts"];
   */
  subscription_contracts?: ContractJson[];

  /**
   * Unset: no type («Неопределено»).
   *
   * @generated from field: optional uint64 pickup_location_type_id = 30 [json_name = "pickup_location_type_id"];
   */
  pickup_location_type_id?: string;

  /**
   * @generated from field: optional raccoonai.OrganizationLabel pickup_location_type = 31 [json_name = "pickup_location_type"];
   */
  pickup_location_type?: OrganizationLabelJson;

  /**
   * @generated from field: required google.protobuf.Timestamp created_at = 101 [json_name = "created_at"];
   */
  created_at?: TimestampJson;
};

/**
 * Describes the message raccoonai.PickupLocation.
 * Use `create(PickupLocationSchema)` to create a new message.
 */
export const PickupLocationSchema: GenMessage<PickupLocation, {jsonType: PickupLocationJson}> = /*@__PURE__*/
  messageDesc(file_pickup_location, 0);

/**
 * @generated from message raccoonai.PickupLocationCreate
 */
export type PickupLocationCreate = Message<"raccoonai.PickupLocationCreate"> & {
  /**
   * to be deprecated
   *
   * @generated from field: optional uint64 owner_organization_id = 1 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;

  /**
   * to be required
   *
   * @generated from field: optional uint64 service_provider_id = 2 [json_name = "service_provider_id"];
   */
  serviceProviderId: bigint;

  /**
   * @generated from field: required string name = 3;
   */
  name: string;

  /**
   * @generated from field: required raccoonai.PickupLocationType type = 4;
   */
  type: PickupLocationType;

  /**
   * @generated from field: required double lon = 5;
   */
  lon: number;

  /**
   * @generated from field: required double lat = 6;
   */
  lat: number;

  /**
   * @generated from field: optional google.protobuf.Struct geometry = 7;
   */
  geometry?: JsonObject;

  /**
   * @generated from field: optional string address = 8;
   */
  address: string;

  /**
   * @generated from field: optional string availability_schedule = 9 [json_name = "availability_schedule"];
   */
  availabilitySchedule: string;

  /**
   * @generated from field: optional string notification_schedule = 10 [json_name = "notification_schedule"];
   */
  notificationSchedule: string;

  /**
   * To be deprecated in favor of container_groups
   *
   * @generated from field: optional uint64 num_containers = 11 [json_name = "num_containers"];
   */
  numContainers: bigint;

  /**
   * To be deprecated
   *
   * @generated from field: optional raccoonai.PickupLocationPriority priority = 12;
   */
  priority: PickupLocationPriority;

  /**
   * To be deprecated
   *
   * @generated from field: optional string geo_group = 13 [json_name = "geo_group"];
   */
  geoGroup: string;

  /**
   * To be deprecated
   *
   * @generated from field: optional uint64 tariff = 14;
   */
  tariff: bigint;

  /**
   * To be deprecated
   *
   * @generated from field: optional uint64 receiver_user_id = 15 [json_name = "receiver_user_id"];
   */
  receiverUserId: bigint;

  /**
   * @generated from field: optional uint64 contract_id = 16 [json_name = "contract_id"];
   */
  contractId: bigint;

  /**
   * @generated from field: optional string comment = 17;
   */
  comment: string;

  /**
   * @generated from field: optional string gis_link = 18 [json_name = "gis_link"];
   */
  gisLink: string;

  /**
   * To be deprecated
   *
   * @generated from field: optional uint64 service_time = 19 [json_name = "service_time"];
   */
  serviceTime: bigint;

  /**
   * To be deprecated
   *
   * @generated from field: optional string plan_waste_volume = 20 [json_name = "plan_waste_volume"];
   */
  planWasteVolume: string;

  /**
   * To be deprecated
   *
   * @generated from field: optional string plan_waste_mass = 21 [json_name = "plan_waste_mass"];
   */
  planWasteMass: string;

  /**
   * @generated from field: optional uint64 manager_id = 22 [json_name = "manager_id"];
   */
  managerId: bigint;

  /**
   * @generated from field: optional uint64 pickup_location_type_id = 23 [json_name = "pickup_location_type_id"];
   */
  pickupLocationTypeId: bigint;
};

/**
 * @generated from message raccoonai.PickupLocationCreate
 */
export type PickupLocationCreateJson = {
  /**
   * to be deprecated
   *
   * @generated from field: optional uint64 owner_organization_id = 1 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;

  /**
   * to be required
   *
   * @generated from field: optional uint64 service_provider_id = 2 [json_name = "service_provider_id"];
   */
  service_provider_id?: string;

  /**
   * @generated from field: required string name = 3;
   */
  name?: string;

  /**
   * @generated from field: required raccoonai.PickupLocationType type = 4;
   */
  type?: PickupLocationTypeJson;

  /**
   * @generated from field: required double lon = 5;
   */
  lon?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: required double lat = 6;
   */
  lat?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional google.protobuf.Struct geometry = 7;
   */
  geometry?: StructJson;

  /**
   * @generated from field: optional string address = 8;
   */
  address?: string;

  /**
   * @generated from field: optional string availability_schedule = 9 [json_name = "availability_schedule"];
   */
  availability_schedule?: string;

  /**
   * @generated from field: optional string notification_schedule = 10 [json_name = "notification_schedule"];
   */
  notification_schedule?: string;

  /**
   * To be deprecated in favor of container_groups
   *
   * @generated from field: optional uint64 num_containers = 11 [json_name = "num_containers"];
   */
  num_containers?: string;

  /**
   * To be deprecated
   *
   * @generated from field: optional raccoonai.PickupLocationPriority priority = 12;
   */
  priority?: PickupLocationPriorityJson;

  /**
   * To be deprecated
   *
   * @generated from field: optional string geo_group = 13 [json_name = "geo_group"];
   */
  geo_group?: string;

  /**
   * To be deprecated
   *
   * @generated from field: optional uint64 tariff = 14;
   */
  tariff?: string;

  /**
   * To be deprecated
   *
   * @generated from field: optional uint64 receiver_user_id = 15 [json_name = "receiver_user_id"];
   */
  receiver_user_id?: string;

  /**
   * @generated from field: optional uint64 contract_id = 16 [json_name = "contract_id"];
   */
  contract_id?: string;

  /**
   * @generated from field: optional string comment = 17;
   */
  comment?: string;

  /**
   * @generated from field: optional string gis_link = 18 [json_name = "gis_link"];
   */
  gis_link?: string;

  /**
   * To be deprecated
   *
   * @generated from field: optional uint64 service_time = 19 [json_name = "service_time"];
   */
  service_time?: string;

  /**
   * To be deprecated
   *
   * @generated from field: optional string plan_waste_volume = 20 [json_name = "plan_waste_volume"];
   */
  plan_waste_volume?: string;

  /**
   * To be deprecated
   *
   * @generated from field: optional string plan_waste_mass = 21 [json_name = "plan_waste_mass"];
   */
  plan_waste_mass?: string;

  /**
   * @generated from field: optional uint64 manager_id = 22 [json_name = "manager_id"];
   */
  manager_id?: string;

  /**
   * @generated from field: optional uint64 pickup_location_type_id = 23 [json_name = "pickup_location_type_id"];
   */
  pickup_location_type_id?: string;
};

/**
 * Describes the message raccoonai.PickupLocationCreate.
 * Use `create(PickupLocationCreateSchema)` to create a new message.
 */
export const PickupLocationCreateSchema: GenMessage<PickupLocationCreate, {jsonType: PickupLocationCreateJson}> = /*@__PURE__*/
  messageDesc(file_pickup_location, 1);

/**
 * @generated from message raccoonai.PickupLocationUpdate
 */
export type PickupLocationUpdate = Message<"raccoonai.PickupLocationUpdate"> & {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id: bigint;

  /**
   * to be deprecated
   *
   * @generated from field: optional uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;

  /**
   * to be required
   *
   * @generated from field: optional uint64 service_provider_id = 3 [json_name = "service_provider_id"];
   */
  serviceProviderId: bigint;

  /**
   * @generated from field: optional string name = 4;
   */
  name: string;

  /**
   * @generated from field: optional raccoonai.PickupLocationType type = 5;
   */
  type: PickupLocationType;

  /**
   * @generated from field: optional raccoonai.LocationStatus status = 6;
   */
  status: LocationStatus;

  /**
   * @generated from field: optional double lon = 7;
   */
  lon: number;

  /**
   * @generated from field: optional double lat = 8;
   */
  lat: number;

  /**
   * @generated from field: optional google.protobuf.Struct geometry = 9;
   */
  geometry?: JsonObject;

  /**
   * @generated from field: optional string address = 10;
   */
  address: string;

  /**
   * @generated from field: optional string availability_schedule = 11 [json_name = "availability_schedule"];
   */
  availabilitySchedule: string;

  /**
   * @generated from field: optional string notification_schedule = 12 [json_name = "notification_schedule"];
   */
  notificationSchedule: string;

  /**
   * @generated from field: optional uint64 num_containers = 13 [json_name = "num_containers"];
   */
  numContainers: bigint;

  /**
   * @generated from field: optional raccoonai.PickupLocationPriority priority = 14;
   */
  priority: PickupLocationPriority;

  /**
   * @generated from field: optional string geo_group = 15 [json_name = "geo_group"];
   */
  geoGroup: string;

  /**
   * @generated from field: optional uint64 tariff = 16;
   */
  tariff: bigint;

  /**
   * @generated from field: optional uint64 receiver_user_id = 17 [json_name = "receiver_user_id"];
   */
  receiverUserId: bigint;

  /**
   * @generated from field: optional uint64 contract_id = 18 [json_name = "contract_id"];
   */
  contractId: bigint;

  /**
   * @generated from field: optional string comment = 19;
   */
  comment: string;

  /**
   * @generated from field: optional string gis_link = 20 [json_name = "gis_link"];
   */
  gisLink: string;

  /**
   * @generated from field: optional uint64 service_time = 21 [json_name = "service_time"];
   */
  serviceTime: bigint;

  /**
   * @generated from field: optional uint64 primary_contact_id = 22 [json_name = "primary_contact_id"];
   */
  primaryContactId: bigint;

  /**
   * @generated from field: optional string plan_waste_volume = 23 [json_name = "plan_waste_volume"];
   */
  planWasteVolume: string;

  /**
   * @generated from field: optional string plan_waste_mass = 24 [json_name = "plan_waste_mass"];
   */
  planWasteMass: string;

  /**
   * @generated from field: optional uint64 manager_id = 25 [json_name = "manager_id"];
   */
  managerId: bigint;

  /**
   * 0 clears
   *
   * @generated from field: optional uint64 pickup_location_type_id = 26 [json_name = "pickup_location_type_id"];
   */
  pickupLocationTypeId: bigint;
};

/**
 * @generated from message raccoonai.PickupLocationUpdate
 */
export type PickupLocationUpdateJson = {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id?: string;

  /**
   * to be deprecated
   *
   * @generated from field: optional uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;

  /**
   * to be required
   *
   * @generated from field: optional uint64 service_provider_id = 3 [json_name = "service_provider_id"];
   */
  service_provider_id?: string;

  /**
   * @generated from field: optional string name = 4;
   */
  name?: string;

  /**
   * @generated from field: optional raccoonai.PickupLocationType type = 5;
   */
  type?: PickupLocationTypeJson;

  /**
   * @generated from field: optional raccoonai.LocationStatus status = 6;
   */
  status?: LocationStatusJson;

  /**
   * @generated from field: optional double lon = 7;
   */
  lon?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional double lat = 8;
   */
  lat?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional google.protobuf.Struct geometry = 9;
   */
  geometry?: StructJson;

  /**
   * @generated from field: optional string address = 10;
   */
  address?: string;

  /**
   * @generated from field: optional string availability_schedule = 11 [json_name = "availability_schedule"];
   */
  availability_schedule?: string;

  /**
   * @generated from field: optional string notification_schedule = 12 [json_name = "notification_schedule"];
   */
  notification_schedule?: string;

  /**
   * @generated from field: optional uint64 num_containers = 13 [json_name = "num_containers"];
   */
  num_containers?: string;

  /**
   * @generated from field: optional raccoonai.PickupLocationPriority priority = 14;
   */
  priority?: PickupLocationPriorityJson;

  /**
   * @generated from field: optional string geo_group = 15 [json_name = "geo_group"];
   */
  geo_group?: string;

  /**
   * @generated from field: optional uint64 tariff = 16;
   */
  tariff?: string;

  /**
   * @generated from field: optional uint64 receiver_user_id = 17 [json_name = "receiver_user_id"];
   */
  receiver_user_id?: string;

  /**
   * @generated from field: optional uint64 contract_id = 18 [json_name = "contract_id"];
   */
  contract_id?: string;

  /**
   * @generated from field: optional string comment = 19;
   */
  comment?: string;

  /**
   * @generated from field: optional string gis_link = 20 [json_name = "gis_link"];
   */
  gis_link?: string;

  /**
   * @generated from field: optional uint64 service_time = 21 [json_name = "service_time"];
   */
  service_time?: string;

  /**
   * @generated from field: optional uint64 primary_contact_id = 22 [json_name = "primary_contact_id"];
   */
  primary_contact_id?: string;

  /**
   * @generated from field: optional string plan_waste_volume = 23 [json_name = "plan_waste_volume"];
   */
  plan_waste_volume?: string;

  /**
   * @generated from field: optional string plan_waste_mass = 24 [json_name = "plan_waste_mass"];
   */
  plan_waste_mass?: string;

  /**
   * @generated from field: optional uint64 manager_id = 25 [json_name = "manager_id"];
   */
  manager_id?: string;

  /**
   * 0 clears
   *
   * @generated from field: optional uint64 pickup_location_type_id = 26 [json_name = "pickup_location_type_id"];
   */
  pickup_location_type_id?: string;
};

/**
 * Describes the message raccoonai.PickupLocationUpdate.
 * Use `create(PickupLocationUpdateSchema)` to create a new message.
 */
export const PickupLocationUpdateSchema: GenMessage<PickupLocationUpdate, {jsonType: PickupLocationUpdateJson}> = /*@__PURE__*/
  messageDesc(file_pickup_location, 2);

/**
 * @generated from message raccoonai.PickupLocationListContract
 */
export type PickupLocationListContract = Message<"raccoonai.PickupLocationListContract"> & {
  /**
   * @generated from field: repeated uint64 pickup_location_ids = 1 [json_name = "pickup_location_ids"];
   */
  pickupLocationIds: bigint[];

  /**
   * @generated from field: required uint64 contract_id = 2 [json_name = "contract_id"];
   */
  contractId: bigint;
};

/**
 * @generated from message raccoonai.PickupLocationListContract
 */
export type PickupLocationListContractJson = {
  /**
   * @generated from field: repeated uint64 pickup_location_ids = 1 [json_name = "pickup_location_ids"];
   */
  pickup_location_ids?: string[];

  /**
   * @generated from field: required uint64 contract_id = 2 [json_name = "contract_id"];
   */
  contract_id?: string;
};

/**
 * Describes the message raccoonai.PickupLocationListContract.
 * Use `create(PickupLocationListContractSchema)` to create a new message.
 */
export const PickupLocationListContractSchema: GenMessage<PickupLocationListContract, {jsonType: PickupLocationListContractJson}> = /*@__PURE__*/
  messageDesc(file_pickup_location, 3);

/**
 * @generated from message raccoonai.PickupLocationList
 */
export type PickupLocationList = Message<"raccoonai.PickupLocationList"> & {
  /**
   * @generated from field: repeated raccoonai.PickupLocation pickup_locations = 1 [json_name = "pickup_locations"];
   */
  pickupLocations: PickupLocation[];

  /**
   * @generated from field: optional raccoonai.ListInfo list_info = 2 [json_name = "list_info"];
   */
  listInfo?: ListInfo;
};

/**
 * @generated from message raccoonai.PickupLocationList
 */
export type PickupLocationListJson = {
  /**
   * @generated from field: repeated raccoonai.PickupLocation pickup_locations = 1 [json_name = "pickup_locations"];
   */
  pickup_locations?: PickupLocationJson[];

  /**
   * @generated from field: optional raccoonai.ListInfo list_info = 2 [json_name = "list_info"];
   */
  list_info?: ListInfoJson;
};

/**
 * Describes the message raccoonai.PickupLocationList.
 * Use `create(PickupLocationListSchema)` to create a new message.
 */
export const PickupLocationListSchema: GenMessage<PickupLocationList, {jsonType: PickupLocationListJson}> = /*@__PURE__*/
  messageDesc(file_pickup_location, 4);

/**
 * One (container group, job type) binding inside a pickup location group.
 *
 * @generated from message raccoonai.ContainerGroupJobTypeLink
 */
export type ContainerGroupJobTypeLink = Message<"raccoonai.ContainerGroupJobTypeLink"> & {
  /**
   * @generated from field: required uint64 container_group_id = 1 [json_name = "container_group_id"];
   */
  containerGroupId: bigint;

  /**
   * @generated from field: required raccoonai.JobType job_type = 2 [json_name = "job_type"];
   */
  jobType: JobType;

  /**
   * display position in the group's list
   *
   * @generated from field: optional uint32 step_idx = 3 [json_name = "step_idx"];
   */
  stepIdx: number;
};

/**
 * One (container group, job type) binding inside a pickup location group.
 *
 * @generated from message raccoonai.ContainerGroupJobTypeLink
 */
export type ContainerGroupJobTypeLinkJson = {
  /**
   * @generated from field: required uint64 container_group_id = 1 [json_name = "container_group_id"];
   */
  container_group_id?: string;

  /**
   * @generated from field: required raccoonai.JobType job_type = 2 [json_name = "job_type"];
   */
  job_type?: JobTypeJson;

  /**
   * display position in the group's list
   *
   * @generated from field: optional uint32 step_idx = 3 [json_name = "step_idx"];
   */
  step_idx?: number;
};

/**
 * Describes the message raccoonai.ContainerGroupJobTypeLink.
 * Use `create(ContainerGroupJobTypeLinkSchema)` to create a new message.
 */
export const ContainerGroupJobTypeLinkSchema: GenMessage<ContainerGroupJobTypeLink, {jsonType: ContainerGroupJobTypeLinkJson}> = /*@__PURE__*/
  messageDesc(file_pickup_location, 5);

/**
 * @generated from message raccoonai.PickupLocationGroup
 */
export type PickupLocationGroup = Message<"raccoonai.PickupLocationGroup"> & {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: required string name = 2;
   */
  name: string;

  /**
   * GetPickupLocationGroupById also sets owner_organization and contract on each.
   *
   * @generated from field: repeated raccoonai.ContainerGroup container_groups = 3 [json_name = "container_groups"];
   */
  containerGroups: ContainerGroup[];

  /**
   * @generated from field: required uint64 owner_organization_id = 4 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;

  /**
   * @generated from field: optional uint64 default_truck_id = 5 [json_name = "default_truck_id"];
   */
  defaultTruckId: bigint;

  /**
   * @generated from field: repeated raccoonai.ContainerGroupJobTypeLink container_group_links = 6 [json_name = "container_group_links"];
   */
  containerGroupLinks: ContainerGroupJobTypeLink[];

  /**
   * "HH:MM" Asia/Almaty, next day's jobs are generated then; unset = off
   *
   * @generated from field: optional string auto_generate_time = 7 [json_name = "auto_generate_time"];
   */
  autoGenerateTime: string;

  /**
   * Distinct pickup locations of container_groups, without their own
   * container_groups. Set by GetPickupLocationGroupById only.
   *
   * @generated from field: repeated raccoonai.PickupLocation pickup_locations = 8 [json_name = "pickup_locations"];
   */
  pickupLocations: PickupLocation[];
};

/**
 * @generated from message raccoonai.PickupLocationGroup
 */
export type PickupLocationGroupJson = {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id?: string;

  /**
   * @generated from field: required string name = 2;
   */
  name?: string;

  /**
   * GetPickupLocationGroupById also sets owner_organization and contract on each.
   *
   * @generated from field: repeated raccoonai.ContainerGroup container_groups = 3 [json_name = "container_groups"];
   */
  container_groups?: ContainerGroupJson[];

  /**
   * @generated from field: required uint64 owner_organization_id = 4 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;

  /**
   * @generated from field: optional uint64 default_truck_id = 5 [json_name = "default_truck_id"];
   */
  default_truck_id?: string;

  /**
   * @generated from field: repeated raccoonai.ContainerGroupJobTypeLink container_group_links = 6 [json_name = "container_group_links"];
   */
  container_group_links?: ContainerGroupJobTypeLinkJson[];

  /**
   * "HH:MM" Asia/Almaty, next day's jobs are generated then; unset = off
   *
   * @generated from field: optional string auto_generate_time = 7 [json_name = "auto_generate_time"];
   */
  auto_generate_time?: string;

  /**
   * Distinct pickup locations of container_groups, without their own
   * container_groups. Set by GetPickupLocationGroupById only.
   *
   * @generated from field: repeated raccoonai.PickupLocation pickup_locations = 8 [json_name = "pickup_locations"];
   */
  pickup_locations?: PickupLocationJson[];
};

/**
 * Describes the message raccoonai.PickupLocationGroup.
 * Use `create(PickupLocationGroupSchema)` to create a new message.
 */
export const PickupLocationGroupSchema: GenMessage<PickupLocationGroup, {jsonType: PickupLocationGroupJson}> = /*@__PURE__*/
  messageDesc(file_pickup_location, 6);

/**
 * @generated from message raccoonai.PickupLocationGroupCreate
 */
export type PickupLocationGroupCreate = Message<"raccoonai.PickupLocationGroupCreate"> & {
  /**
   * @generated from field: required string group_name = 1 [json_name = "name"];
   */
  groupName: string;

  /**
   * @generated from field: optional uint64 owner_organization_id = 4 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;

  /**
   * @generated from field: optional uint64 default_truck_id = 5 [json_name = "default_truck_id"];
   */
  defaultTruckId: bigint;

  /**
   * "HH:MM"; unset = off
   *
   * @generated from field: optional string auto_generate_time = 6 [json_name = "auto_generate_time"];
   */
  autoGenerateTime: string;
};

/**
 * @generated from message raccoonai.PickupLocationGroupCreate
 */
export type PickupLocationGroupCreateJson = {
  /**
   * @generated from field: required string group_name = 1 [json_name = "name"];
   */
  name?: string;

  /**
   * @generated from field: optional uint64 owner_organization_id = 4 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;

  /**
   * @generated from field: optional uint64 default_truck_id = 5 [json_name = "default_truck_id"];
   */
  default_truck_id?: string;

  /**
   * "HH:MM"; unset = off
   *
   * @generated from field: optional string auto_generate_time = 6 [json_name = "auto_generate_time"];
   */
  auto_generate_time?: string;
};

/**
 * Describes the message raccoonai.PickupLocationGroupCreate.
 * Use `create(PickupLocationGroupCreateSchema)` to create a new message.
 */
export const PickupLocationGroupCreateSchema: GenMessage<PickupLocationGroupCreate, {jsonType: PickupLocationGroupCreateJson}> = /*@__PURE__*/
  messageDesc(file_pickup_location, 7);

/**
 * @generated from message raccoonai.PickupLocationGroupList
 */
export type PickupLocationGroupList = Message<"raccoonai.PickupLocationGroupList"> & {
  /**
   * @generated from field: repeated raccoonai.PickupLocationGroup pickup_location_groups = 1 [json_name = "pickup_location_groups"];
   */
  pickupLocationGroups: PickupLocationGroup[];

  /**
   * @generated from field: optional raccoonai.ListInfo list_info = 2 [json_name = "list_info"];
   */
  listInfo?: ListInfo;
};

/**
 * @generated from message raccoonai.PickupLocationGroupList
 */
export type PickupLocationGroupListJson = {
  /**
   * @generated from field: repeated raccoonai.PickupLocationGroup pickup_location_groups = 1 [json_name = "pickup_location_groups"];
   */
  pickup_location_groups?: PickupLocationGroupJson[];

  /**
   * @generated from field: optional raccoonai.ListInfo list_info = 2 [json_name = "list_info"];
   */
  list_info?: ListInfoJson;
};

/**
 * Describes the message raccoonai.PickupLocationGroupList.
 * Use `create(PickupLocationGroupListSchema)` to create a new message.
 */
export const PickupLocationGroupListSchema: GenMessage<PickupLocationGroupList, {jsonType: PickupLocationGroupListJson}> = /*@__PURE__*/
  messageDesc(file_pickup_location, 8);

/**
 * @generated from message raccoonai.PickupLocationGroupUpdate
 */
export type PickupLocationGroupUpdate = Message<"raccoonai.PickupLocationGroupUpdate"> & {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: optional string group_name = 2 [json_name = "name"];
   */
  groupName: string;

  /**
   * @generated from field: optional uint64 owner_organization_id = 4 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;

  /**
   * @generated from field: optional uint64 default_truck_id = 5 [json_name = "default_truck_id"];
   */
  defaultTruckId: bigint;

  /**
   * "HH:MM"; "" turns it off
   *
   * @generated from field: optional string auto_generate_time = 6 [json_name = "auto_generate_time"];
   */
  autoGenerateTime: string;
};

/**
 * @generated from message raccoonai.PickupLocationGroupUpdate
 */
export type PickupLocationGroupUpdateJson = {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id?: string;

  /**
   * @generated from field: optional string group_name = 2 [json_name = "name"];
   */
  name?: string;

  /**
   * @generated from field: optional uint64 owner_organization_id = 4 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;

  /**
   * @generated from field: optional uint64 default_truck_id = 5 [json_name = "default_truck_id"];
   */
  default_truck_id?: string;

  /**
   * "HH:MM"; "" turns it off
   *
   * @generated from field: optional string auto_generate_time = 6 [json_name = "auto_generate_time"];
   */
  auto_generate_time?: string;
};

/**
 * Describes the message raccoonai.PickupLocationGroupUpdate.
 * Use `create(PickupLocationGroupUpdateSchema)` to create a new message.
 */
export const PickupLocationGroupUpdateSchema: GenMessage<PickupLocationGroupUpdate, {jsonType: PickupLocationGroupUpdateJson}> = /*@__PURE__*/
  messageDesc(file_pickup_location, 9);

